import { GET_ADMIN_USERS } from './constants';

const initialState = {
  isLoading: false,
  users: [],
  pagination: null,
};

export const adminUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_USERS:
      return {
        ...state,
        isLoading: true,
      };
    case `${GET_ADMIN_USERS}/result`:
      return {
        ...state,
        isLoading: false,
        users: action.response.data || [],
        pagination: {
          offset: action.response.offset || 0,
          limit: action.response.limit || 10,
          totalRecords: action.response.totalRecords || 0,
        },
      };
    case `${GET_ADMIN_USERS}/error`:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};
